import { GRAD_CATEGORY_OPTIONS, GradCategory, SalaryTableItemPrefix } from '@agent-ds/shared/interfaces/job-az-check';

export function getGradCategoryLabel(category: GradCategory): string {
  const option = GRAD_CATEGORY_OPTIONS.find((o) => o.gradCategory === category);
  if (!option) {
    return '';
  }
  return option.label;
}

export function buildSalaryTableKey(itemPrefix: SalaryTableItemPrefix, category: GradCategory): string {
  return `${itemPrefix}${category}`;
}

/**
 * 給与補足（salaryTable.salaryDescriptionNonEditableDisplay）の非編集テキストを組み立てる。
 * 月給（卒業種別別）・固定の深夜割増手当・変形労働時間制の反映内容を改行区切りで連結したもの。
 * DynamicFieldService（表示用supplier）とSalaryTableRowsService（文字数上限バリデーション）の
 * 双方から同じロジックを参照するため、共通関数として切り出している。
 */
export function buildSalaryDescriptionNonEditableText(salaryTable: { [key: string]: any }): string {
  return [
    salaryTable.salaryDescriptionSalaryByGraduateCategory,
    salaryTable.salaryDescriptionFixedLateNightOvertime,
    salaryTable.salaryDescriptionVariableWorkingHoursSystem,
  ]
    .filter((v) => v)
    .join('\n');
}
